import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { Layout } from 'containers';
import { Breadcrumb, FeatherIcon, Loader } from 'components';
import { FinanceApplicationsProvider } from 'providers';

const FinanceApplications = () => {
    const [ pageLoading, setPageLoading ] = useState(true);
    const [ applications, setApplications ] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
            const data = await FinanceApplicationsProvider.getAll();
            setApplications(data.results);
            setPageLoading(false);
		};
		fetchData();
    }, [ setApplications, setPageLoading ]);

    return (
        <Layout>
			{pageLoading && <Loader />}
			<Breadcrumb
                title="Finance Applications"
			/>
            <Row className="inbox-wrapper">
                <Col lg={12}>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col lg={12} className="email-content">
                                    <div className="email-inbox-header">
                                        <Row className="row align-items-center">
                                            <Col lg={6}>
                                                <div className="email-title mb-2 mb-md-0">
                                                    <span className="icon">
                                                        <FeatherIcon icon="database" />
                                                    </span> Finance Applications&nbsp;
                                                    {/* <span className="new-messages">(2 new applications)</span> */}
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="email-search">
                                                    <div className="input-group input-search">
                                                        <input className="form-control" type="text" placeholder="Search applications..." />
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-outline-secondary" type="button">
                                                                <FeatherIcon icon="search" />
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
							<div className="table-responsive">
								<table className="table table-hover mb-0">
									<thead>
										<tr>
											<th className="pt-0">#</th>
											<th className="pt-0">Customer</th>
											<th className="pt-0">Vehicle</th>
											<th className="pt-0">Date</th>
                                            <th className="pt-0 text-right">Actions</th>
										</tr>
									</thead>
									<tbody>
                                        {applications.length > 0 && applications.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td>{idx + 1}</td>
                                            <td>{item.customer.title} {item.customer.first_name[0]} {item.customer.last_name} - {item.customer.id_number}</td>
                                            <td>{item.year} {item.make} {item.model} - {item.reg_number}</td>
                                            <td>{moment(item.created).format('DD MMM, YYYY')}</td>
                                            <td className="text-right"></td>
                                        </tr>))}
                                        {applications.length === 0 &&
                                        <tr><td colSpan={12} className="text-center">No application record available</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default FinanceApplications;
